// Observability — must run before any other import that can throw or fetch
// so OTel auto-instrumentations and Sentry are installed first.
import './observability/otel';
import './observability/sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import '/node_modules/flag-icons/css/flag-icons.min.css';

import { store } from './store.ts';
import './index.css';
import App from './App.tsx';
import { theme } from './theme.ts';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </Provider>
  </StrictMode>
);
